import axios from 'axios'
import { env } from '../utilities/helpers'

const koalition = axios.create({
    baseURL: env.BACKEND_URL,
    headers: {
        'Content-Type': 'application/json'
    }
})

const jwt = localStorage.jwt

if (jwt) koalition.defaults.headers.common.Authorization = `Bearer ${jwt}`

export default koalition